import { render } from "./FooterComp.vue?vue&type=template&id=a7a995ae"
import script from "./FooterComp.vue?vue&type=script&lang=js"
export * from "./FooterComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__